interface DefaultTanstackConfig {
    queries: {
        staleTime: number;
        cacheTime: number;
    }
}
export const defaultTanstackConfig: DefaultTanstackConfig = {
    queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 5 * 60 * 1000, // 5 minutes
    }
}